export default "__VITE_ASSET__BtZRsERf__"